import { render, staticRenderFns } from "./coverageComparisonMap.vue?vue&type=template&id=87bcd96c&scoped=true"
import script from "./coverageComparisonMap.vue?vue&type=script&lang=js"
export * from "./coverageComparisonMap.vue?vue&type=script&lang=js"
import style0 from "./coverageComparisonMap.vue?vue&type=style&index=0&id=87bcd96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bcd96c",
  null
  
)

export default component.exports